import {
  jb_article_page_hero_css_default
} from "./chunk.ZPH2HZG2.js";
import {
  Spaceable
} from "./chunk.P6YYTXAQ.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  n
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-article-page-hero/jb-article-page-hero.ts
var JbArticlePageHero = class extends Spaceable(r) {
  _getContentSpacingProperties() {
    return {
      colsMdUp: 10,
      type: "text"
    };
  }
  render() {
    return ke`
      <article class="push-left">
        <header>
          ${this.breadcrumbs && ke`
            <jb-breadcrumbs>
              ${this.breadcrumbs.backlink && ke`<jb-breadcrumbs-back-link
                .link=${this.breadcrumbs.backlink.link}
                .text=${this.breadcrumbs.backlink.text}
                slot="backlink"
              ></jb-breadcrumbs-back-link>`}
              ${this.breadcrumbs.items?.map(
      (breadcrumb) => ke`<jb-breadcrumbs-item
                    .link=${breadcrumb.link}
                    .text=${breadcrumb.text}
                    slot="items"
                  ></jb-breadcrumbs-item>`
    )}
            </jb-breadcrumbs>
          `}
          ${this.headline && ke`<h1>${this.headline}</h1>`}
          <div class="article-meta">
            <div class="article-meta__author">
              <div class="article-meta__author-inner">
                ${this.date && ke`<jb-date date=${this.date}></jb-date>`} ${this.author && ke`${this.author}`}
              </div>
            </div>
            <div class="article-meta__time">
              <div class="article-meta__time-wrapper">
                <div class="article-meta__time-icon">
                  <jb-clock-icon></jb-clock-icon>
                </div>
                <div class="article-meta__time-text">${this.readingTime && ke`${this.readingTime}`}</div>
              </div>
            </div>
          </div>
        </header>
        <div class="media-image-wrap">
          <div class="column">
            <div class="media-image__wrap">
              <figure class="media-image-aspect">
                <jb-image .picture=${this.image.picture}></jb-image>
              </figure>
            </div>
          </div>
          <div>
            ${this.image.caption && ke`<p class="caption">${this.image.caption}</p>`}
            ${this.image.text && ke`<p class="text">${this.image.text}</p>`}
            ${this.image.credit && ke`<p class="credit">${this.image.credit}</p>`}
          </div>
        </div>

        <div class="text-wrap">
          <div class="text">${this.text && ke`<p>${this.text}</p>`}</div>
        </div>
      </article>
    `;
  }
};
JbArticlePageHero.styles = jb_article_page_hero_css_default;
__decorateClass([
  n()
], JbArticlePageHero.prototype, "author", 2);
__decorateClass([
  n({ type: Object })
], JbArticlePageHero.prototype, "breadcrumbs", 2);
__decorateClass([
  n()
], JbArticlePageHero.prototype, "date", 2);
__decorateClass([
  n()
], JbArticlePageHero.prototype, "headline", 2);
__decorateClass([
  n({ type: Object })
], JbArticlePageHero.prototype, "image", 2);
__decorateClass([
  n()
], JbArticlePageHero.prototype, "readingTime", 2);
__decorateClass([
  n()
], JbArticlePageHero.prototype, "text", 2);
JbArticlePageHero = __decorateClass([
  customElement("jb-article-page-hero")
], JbArticlePageHero);

export {
  JbArticlePageHero
};
